/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:53:03]
Permissions to update outside the main branch: [false]
*/

import { requiredRule, toDisplayRoleType, ValidatedInput } from '@finbeat/react-toolkit';
import { RoleType } from 'models/api/roles';
import { useGeneralSettingsContext } from 'providers/GeneralSettingsProvider';
import { useTranslation } from 'react-i18next';
import { RoleChangeModalFromType } from './RoleChangeModal';

const RoleChangeModalTabInfo = ({
    formHasRole,
    roleTypes,
}: {
    formHasRole: () => boolean;
    roleTypes: RoleType[];
}) => {
    const { t } = useTranslation();
    const { cultures } = useGeneralSettingsContext();

    return (
        <>
            <ValidatedInput<RoleChangeModalFromType>
                id="info-name-field"
                name="name"
                label={t('BackOfficeCode')}
                rules={{
                    required: requiredRule,
                }}
                disabled={!formHasRole()}
            />
            <ValidatedInput<RoleChangeModalFromType>
                id="info-dsc-field"
                type="textarea"
                name="dsc"
                label={t('BackOfficeDescription')}
                disabled={!formHasRole()}
            />
            <ValidatedInput<RoleChangeModalFromType>
                id="ds-isActive"
                name="isActive"
                type="checkbox"
                disabled={!formHasRole()}
                label={t('BackOfficeIsActive')}
            />
            <ValidatedInput<RoleChangeModalFromType>
                id="ds-isTechnical"
                name="isTechnical"
                type="checkbox"
                disabled={!formHasRole()}
                label={t('BackOfficeIsTechnicalRole')}
            />
            <ValidatedInput<RoleChangeModalFromType>
                id="info-rank-field"
                name="rank"
                label={t('BackOfficeRank')}
                rules={{
                    required: requiredRule,
                }}
                disabled={!formHasRole()}
            />

            <ValidatedInput<RoleChangeModalFromType>
                id="ds-typeId"
                type="select"
                label={t('BackOfficeType')}
                name="typeId"
                options={roleTypes.map((r, i) => (
                    <option key={i} value={r.id}>
                        {toDisplayRoleType(r.code, t)}
                    </option>
                ))}
                rules={{
                    required: requiredRule,
                }}
                loading={!roleTypes.length}
            />
            {cultures &&
                cultures.map((culture, index) => (
                    <ValidatedInput<RoleChangeModalFromType>
                        key={culture.code}
                        id={'info-dsc-field' + index}
                        name={`nameTranslations.${culture.code}`}
                        label={`${t('BackOfficeName')} ${culture.name}`}
                        disabled={!formHasRole()}
                    />
                ))}
        </>
    );
};

export default RoleChangeModalTabInfo;
